export const filterTypes = {
  contact: "CONTACT",
  user: "USER",
  socialPost: "SOCIAL_POST",
  newsPost: "NEWS_POST",
  page: "PAGE",
  registrationForm: "REGISTRATION_FORM",
  registrationPost: "REGISTRATION_POST",
};
